import InfinitelyScrolled from './InfinitelyScrolled';

export default InfinitelyScrolled;
